import requests from '../../../request'

const baseUrl = '/stock/take/sheet';
const adjustBaseUrl = '/stock/adjust';
const region = 'cloud-api';

const ContentTypeEnum = {
    // json
    JSON: 'application/json;charset=UTF-8',
    // form-data qs
    FORM_URLENCODED: 'application/x-www-form-urlencoded;charset=UTF-8',
    // form-data  upload
    BLOB: 'multipart/form-data;charset=UTF-8',
}

/**
 * 查询列表
 */
export function query(params) {
  return requests({
    method: 'get',
    url: baseUrl + '/query',
    params,
  }, {
    region,
  });
}

/**
 * 查询盘点单详情
 * @param {Object} params
 * @param {string} params.id 盘点单ID
 * @param {number} [params.pageIndex]
 * @param {number} [params.pageSize]
 * @param {string} [params.categoryId]
 * @param {string} [params.keyword]
 * @param {string} [params.externalCode]
 * @param {boolean} [params.unTake]
 */
export function getDetail(params) {
  return requests({
    method: 'get',
    url: baseUrl + '/detail',
    params,
  }, {
    region,
  });
}

/**
 * 根据关键字查询商品列表
 */
export function searchProducts(planId, condition) {
  return requests({
    method: 'get',
    url: baseUrl + '/product/search',
    params: {
      planId,
      condition,
    },
  }, {
    region,
  });
}

/**
 * 查询商品列表
 */
export function queryProductList(params) {
  return requests({
    method: 'get',
    url: baseUrl + '/product/list',
    params,
  }, {
    region,
  });
}

/**
 * 新增
 */
export function create(data) {
  return requests({
    method: 'post',
    url: baseUrl,
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 修改
 */
export function update(data) {
  return requests({
    method: 'put',
    url: baseUrl,
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 直接审核通过
 */
export function directApprovePass(data) {
  return requests({
    method: 'post',
    url: baseUrl + '/approve/direct',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 审核通过
 */
export function approvePass(params) {
  return requests({
    method: 'patch',
    url: baseUrl + '/approve/pass',
    params,
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 批量审核通过
 */
export function batchApprovePass(data) {
  return requests({
    method: 'patch',
    url: baseUrl + '/approve/pass/batch',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 审核拒绝
 */
export function approveRefuse(data) {
  return requests({
    method: 'patch',
    url: baseUrl + '/approve/refuse',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 批量审核拒绝
 */
export function batchApproveRefuse(data) {
  return requests({
    method: 'patch',
    url: baseUrl + '/approve/refuse/batch',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 取消审核
 */
export function cancelApprovePass(id) {
  return requests({
    method: 'patch',
    url: baseUrl + '/approve/cancel',
    params: {
      id,
    },
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 删除
 */
export function deleteById(id) {
  return requests({
    method: 'delete',
    url: baseUrl,
    params: {
      id,
    },
  }, {
    region,
    contentType: ContentTypeEnum.FORM_URLENCODED,
  });
}

/**
 * 批量删除
 */
export function deleteByIds(ids) {
  return requests({
    method: 'delete',
    url: baseUrl + '/batch',
    data: ids,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}
/**
 * 查询关联任务列表
 */
export function queryTaskList(params) {
  return requests({
    method: 'get',
    url: '/stock/take/plan/query',
    params,
  }, {
    region,
  });
}
/**
 * 查询关联任务详情
 */
export function getTaskDetail(id) {
  return requests({
    method: 'get',
    url: '/stock/take/plan/detail',
    params,
  }, {
    region,
  });
}
/**
 * 关联任务
 */
export function associateTask(data) {
  return requests({
    method: 'post',
    url: '/stock/take/plan/associate',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

/**
 * 修改盘点单（库存调整）
 */
export function adjust(data) {
  return requests({
    method: 'put',
    url: adjustBaseUrl,
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

export function addProductTakeNum(data) {
  return requests({
    method: 'post',
    url: baseUrl + '/product/take-num',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

export function deleteProduct(data) {
  return requests({
    method: 'delete',
    url: baseUrl + '/product',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

export function updateDescription(data) {
  return requests({
    method: 'put',
    url: baseUrl + '/description',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

export function addProduct(data) {
  return requests({
    method: 'post',
    url: baseUrl + '/product',
    data,
  }, {
    region,
    contentType: ContentTypeEnum.JSON,
  });
}

